import { useEffect, useState } from "react";
import axios from "axios";
import { INSIGHTS, IMG } from "@/lib/data";
import { API, coverUrl, formatDate } from "@/lib/blogApi";

export const normalizeArticle = (post) => ({
  ...post, image: coverUrl(post.cover_id) || IMG.cargoShip,
  date: formatDate(post.published_at), readTime: post.read_time || "1 min read",
});

export function useArticles(pageSize = 12) {
  const [live, setLive] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    axios.get(`${API}/posts`, { params: { limit: pageSize }, signal: controller.signal })
      .then(({ data }) => { setLive(data.map(normalizeArticle)); setHasMore(data.length === pageSize); setError(false); })
      .catch((e) => { if (!axios.isCancel(e)) setError(true); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [pageSize]);
  const loadMore = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/posts`, { params: { limit: pageSize, offset: live.length } });
      setLive((items) => [...items, ...data.map(normalizeArticle)]);
      setHasMore(data.length === pageSize);
      setError(false);
    } catch { setError(true); } finally { setLoading(false); }
  };
  return { articles: [...live, ...INSIGHTS], loading, error, hasMore, loadMore };
}

export function useArticle(slug) {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const sample = INSIGHTS.find((item) => item.slug === slug);
    setArticle(sample || null); setError(null); setLoading(!sample);
    if (sample) return;
    const controller = new AbortController();
    axios.get(`${API}/posts/${encodeURIComponent(slug)}`, { signal: controller.signal })
      .then(({ data }) => setArticle(normalizeArticle(data)))
      .catch((e) => { if (!axios.isCancel(e)) setError(e.response?.status === 404 ? "not-found" : "unavailable"); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [slug]);
  return { article, loading, error };
}